export const SMS_HISTORY_STORE = 'SMS_HISTORY_STORE';
export const SMS_HISTORY_UPDATE = 'SMS_HISTORY_UPDATE';
export const SMS_HISTORY_DESTROY = 'SMS_HISTORY_DESTROY';
